import { includeOfferEligibilityDetails } from '../common/utils';
import { getDataFromAPI } from './servicesClient';

const offerEligibility = async (incentiveObj) =>
  getDataFromAPI(
    'offerEligibility',
    null,
    'POST',
    includeOfferEligibilityDetails(incentiveObj),
  ).then((response) => ({ response }));

export { offerEligibility };
